export enum View2dType {
  rooms = 'app.rooms',
  area = 'app.area',
  numeration = 'app.numeration',
  price = 'app.price',
  priceAlternative = 'app.priceAlternative',
  pricePM = 'app.pricePM',
  pricePMAlternative = 'app.pricePMAlternative',
  row0 = 'app.row0',
  row1 = 'app.row1',
  row2 = 'app.row2',
  row3 = 'app.row3',
  row4 = 'app.row4',
  row5 = 'app.row5',
  row6 = 'app.row6',
  row7 = 'app.row7',
  row8 = 'app.row8',
  row9 = 'app.row9',
  row10 = 'app.row10',
  row11 = 'app.row11',
  row12 = 'app.row12',
  row13 = 'app.row13',
  row14 = 'app.row14',
  row15 = 'app.row15',
  row16 = 'app.row16',
  row17 = 'app.row17',
  row18 = 'app.row18',
  row19 = 'app.row19',
}
